/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TechLogsValidationRequest
 */
export interface TechLogsValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof TechLogsValidationRequest
     */
    correlationId?: string | null;
}

export function TechLogsValidationRequestFromJSON(json: any): TechLogsValidationRequest {
    return TechLogsValidationRequestFromJSONTyped(json, false);
}

export function TechLogsValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TechLogsValidationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correlationId': !exists(json, 'correlationId') ? undefined : json['correlationId'],
    };
}

export function TechLogsValidationRequestToJSON(value?: TechLogsValidationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correlationId': value.correlationId,
    };
}


